module.exports = __webpack_public_path__ + "img/art4.88cfbd70.png";